import React, { useState, useEffect } from "react";
import "../styles/Gallery.css";



const Home = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {  
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-page">



      <div className="container text-animation-container">
        <div className="animated-textga">
          <div className=".container.visible ">
          </div>
          Explore the SSB Academy Gallery – A glimpse into our expert training sessions and success stories

        </div>
      </div>

 
      <div className="bg-image-containergl">
        {/* <div className="centered-text">
          Prepare for Excellence
        </div> */}
      </div>

   




     



      {showScrollButton && (
        <div className="scroll-to-top">
          <button onClick={scrollToTop}>
            ↑
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;